import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MB_SVG_Play = React.memo((props: {
    /**
     * The size of the component.
     */
    size?: number,

    /**
     * The color of the component.
     */
    color?: string,

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={props.size ?? 23}
                height={props.size ? (props.size * (29 / 23)) : 29}
                viewBox="0 0 23 29"
                fill="none"
            >
                <Path
                    d="M1.75 1L22 14.5 1.75 28V1z"
                    fill={props.color ?? "#fff"}
                    stroke={props.color ?? "#fff"}
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </Svg>
        </View>
    );
});

export { MB_SVG_Play };
